var version = {
    "name":      "dativery",
    "buildDateCode": "20251127-190355",
    "buildDate": "Thu Nov 27 2025 19:03:55 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251127-190355",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;